<template>
  <main class="admin-inbox" dir="rtl">
    <header class="inbox-header"><div><span class="inbox-eyebrow">صندوق شخصی پروژه</span><h1>اعلان‌ها</h1><p>گفتگوهای تازه و رویدادهای مرتبط با کار شما در این پروژه</p></div><div class="unread-summary"><span>{{ number(unreadCount) }}</span> خوانده‌نشده</div></header>
    <div class="inbox-toolbar"><div><h2>تازه‌ترین رویدادها</h2><small>{{ number(total) }} اعلان ثبت‌شده</small></div><div><button type="button" :disabled="busy" @click="load(true)">به‌روزرسانی</button><button v-if="unreadCount && loaded" type="button" :disabled="busy" @click="markAllRead">خواندن همه</button></div></div>
    <div v-if="error" class="inbox-error" role="alert">{{ error }} <button type="button" :disabled="busy" @click="load(true)">تلاش دوباره</button></div>
    <div v-if="loading && !loaded" class="inbox-loading" role="status">در حال دریافت اعلان‌ها…</div>
    <EmptyState v-else-if="loaded && !items.length" kind="notifications" title="هنوز اعلانی ندارید" description="پیام‌های مربوط به شما پس از ثبت، همین‌جا نمایش داده می‌شوند." />
    <div v-else class="inbox-list"><button v-for="item in items" :key="item.id" type="button" class="inbox-item" :class="{ unread: !item.read_at }" :disabled="busy" @click="openItem(item)"><span class="item-icon" aria-hidden="true">{{ ({ ticket_incoming: '✉', ticket_reply: '✉', visit_reviewed: '✓', visit_assigned: '+' })[item.kind] || '◌' }}</span><span class="item-copy"><strong>{{ item.title }}<i v-if="!item.read_at" aria-label="خوانده‌نشده"></i></strong><span>{{ item.body }}</span><small>{{ date(item.created_at) }}</small></span><span class="item-arrow" aria-hidden="true">‹</span></button></div>
    <button v-if="loaded && nextOffset !== null" type="button" class="inbox-more" :disabled="busy" @click="load(false)">نمایش اعلان‌های بیشتر</button>
  </main>
</template>

<script>
import EmptyState from '@/components/EmptyState/index.vue';
export default {
  components: { EmptyState },
  name: 'AdminNotifications',
  data() { return { items: [], total: 0, unreadCount: 0, nextOffset: null,
    loading: false, loaded: false, saving: false, error: '', sequence: 0 }; },
  computed: {
    project() { return this.$STORE.state.userConfig.setProjectId; },
    busy() { return this.loading || this.saving; },
  },
  created() { this.load(true); },
  beforeDestroy() { this.sequence += 1; },
  watch: {
    project() {
      this.sequence += 1; this.items = []; this.total = 0; this.unreadCount = 0;
      this.nextOffset = null; this.loading = false; this.loaded = false; this.saving = false;
      this.error = ''; this.load(true);
    },
  },
  methods: {
    number(value) { return Number(value || 0).toLocaleString('fa-IR'); },
    date(value) { if (!value) return 'زمان نامشخص'; const parsed = new Date(value); return Number.isNaN(parsed.getTime()) ? 'زمان نامشخص' : parsed.toLocaleString('fa-IR', { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' }); },
    apiError(response) { return (response.data && (response.data.detail || response.data.message)) || 'دریافت اطلاعات ممکن نشد.'; },
    async load(reset) {
      if (!this.project || this.busy) return;
      const project = this.project;
      const sequence = ++this.sequence;
      const offset = reset ? 0 : this.nextOffset;
      if (offset === null) return;
      this.loading = true; this.error = '';
      try {
        const response = await this.$ApiServiceLayer.get(`/core/api/notifications/?p=${project}&limit=20&offset=${offset}`);
        if (sequence !== this.sequence || project !== this.project) return;
        if (response.status !== 200) { this.error = this.apiError(response); return; }
        const data = response.data || {};
        this.items = reset ? (data.results || []) : [...this.items, ...(data.results || [])];
        this.total = Number(data.count || 0); this.unreadCount = Number(data.unread_count || 0);
        this.$root.$emit('notifications-updated', { project, unreadCount: this.unreadCount });
        this.nextOffset = data.next_offset == null ? null : Number(data.next_offset);
        this.loaded = true;
      } catch (_) { if (sequence === this.sequence && project === this.project) this.error = 'دریافت اعلان‌ها ممکن نشد. دوباره تلاش کنید.'; }
      finally { if (sequence === this.sequence && project === this.project) this.loading = false; }
    },
    async openItem(item) {
      if (this.busy) return;
      const project = this.project;
      const sequence = this.sequence;
      this.saving = true; this.error = '';
      try {
        if (!item.read_at) {
          const response = await this.$ApiServiceLayer.post(`/core/api/notifications/${item.id}/read/?p=${project}`, '', {});
          if (sequence !== this.sequence || project !== this.project) return;
          if (response.status === 200) { item.read_at = response.data.read_at; this.unreadCount = Math.max(0, this.unreadCount - 1); this.$root.$emit('notifications-updated', { project, unreadCount: this.unreadCount }); }
          else this.error = this.apiError(response);
        }
      } catch (_) { if (sequence === this.sequence && project === this.project) this.error = 'ثبت وضعیت اعلان ممکن نشد.'; }
      finally { if (sequence === this.sequence && project === this.project) this.saving = false; }
      if (sequence === this.sequence && project === this.project && ['ticket_incoming', 'ticket_reply'].includes(item.kind) && item.object_id) {
        this.$router.push({ name: 'ticketDetail', params: { id: item.object_id } }, () => {}, () => {});
      }
      if (sequence === this.sequence && project === this.project && ['visit_reviewed', 'visit_assigned'].includes(item.kind) && item.object_id) {
        this.$router.push('/visitmanagment/answerlist/' + item.object_id, () => {}, () => {});
      }
    },
    async markAllRead() {
      if (!this.project || this.busy) return;
      const project = this.project;
      const sequence = this.sequence;
      this.saving = true; this.error = '';
      try {
        const response = await this.$ApiServiceLayer.post(`/core/api/notifications/read-all/?p=${project}`, '', {});
        if (sequence !== this.sequence || project !== this.project) return;
        if (response.status !== 200) { this.error = this.apiError(response); return; }
        const now = new Date().toISOString();
        this.items.forEach(item => { if (!item.read_at) item.read_at = now; });
        this.unreadCount = Number(response.data.unread_count || 0);
        this.$root.$emit('notifications-updated', { project, unreadCount: this.unreadCount });
      } catch (_) { if (sequence === this.sequence && project === this.project) this.error = 'ثبت وضعیت اعلان‌ها ممکن نشد.'; }
      finally { if (sequence === this.sequence && project === this.project) this.saving = false; }
    },
  },
};
</script>

<style scoped>
.admin-inbox { color: var(--text); }
.inbox-header { position: relative; display: flex; justify-content: space-between; align-items: flex-end; gap: 16px; padding: 24px 26px; border-radius: var(--r-md); background: var(--navy-900); color: #fff; overflow: hidden; }
.inbox-header::after { content: ''; position: absolute; inset-inline: 0; bottom: 0; height: 3px; background: var(--bars); }
.inbox-eyebrow { font-size: 12px; color: var(--navy-300); }
.inbox-header h1 { font-size: 24px; font-weight: 950; color: #fff; margin: 4px 0; }
.inbox-header p { font-size: 13px; color: var(--navy-300); margin: 0; line-height: 1.8; }
.unread-summary { padding: 8px 14px; background: var(--amber-500); color: var(--navy-900); font-size: 13px; font-weight: 800; white-space: nowrap; transform: skewX(var(--slant)); }
.unread-summary span { font-size: 20px; font-weight: 950; font-family: var(--font-num); }
.inbox-toolbar { display: flex; justify-content: space-between; align-items: center; gap: 14px; margin: 22px 0 14px; }
.inbox-toolbar h2 { font-size: 17px; font-weight: 900; margin: 0; }
.inbox-toolbar small { color: var(--text-3); font-family: var(--font-num); }
.inbox-toolbar > div:last-child { display: flex; gap: 8px; }
.inbox-toolbar button, .inbox-more { min-height: 42px; padding: 8px 14px; border: 1px solid var(--line-strong); border-radius: var(--r-xs); background: var(--surface); color: var(--text); font-size: 13px; font-weight: 800; }
.inbox-toolbar button:hover, .inbox-more:hover { border-color: var(--navy-900); }
.inbox-error { padding: 12px 14px; border-inline-start: 4px solid var(--pink-700); background: var(--pink-50); color: var(--pink-700); margin-bottom: 14px; }
.inbox-error button { border: 0; background: none; color: var(--navy-900); font-weight: 800; text-decoration: underline; }
.inbox-loading { padding: 40px 20px; border: 1px dashed var(--line-strong); border-radius: var(--r-md); background: var(--surface); text-align: center; color: var(--text-3); }
.inbox-list { display: grid; gap: 8px; }
.inbox-item { position: relative; display: flex; align-items: center; gap: 14px; width: 100%; padding: 14px 16px; border: 1px solid var(--line); border-radius: var(--r-md); background: var(--surface); text-align: right; color: var(--text); transition: border-color .15s, box-shadow .2s var(--ease-out); }
.inbox-item:hover:not(:disabled) { border-color: var(--navy-900); box-shadow: 3px 3px 0 var(--navy-900); }
.inbox-item.unread::before { content: ''; position: absolute; inset-inline-start: -1px; top: 12px; bottom: 12px; width: 4px; background: var(--pink-500); transform: skewY(var(--slant)); }
.item-icon { width: 42px; height: 42px; flex: none; display: grid; place-items: center; border-radius: var(--r-sm); background: var(--navy-900); color: var(--teal-300); font-size: 20px; }
.unread .item-icon { background: var(--teal-500); color: var(--navy-900); }
.item-copy { display: grid; gap: 4px; flex: 1; min-width: 0; }
.item-copy strong { font-size: 14px; font-weight: 900; overflow-wrap: anywhere; }
.item-copy strong i { display: inline-block; width: 8px; height: 8px; margin: 0 8px; background: var(--pink-500); transform: skewX(var(--slant)); }
.item-copy > span { font-size: 12.5px; color: var(--text-2); overflow-wrap: anywhere; }
.item-copy small { font-size: 11.5px; color: var(--text-3); }
.item-arrow { color: var(--text-4); font-size: 26px; }
.inbox-more { width: 100%; margin-top: 12px; }
.admin-inbox button:disabled { opacity: .55; cursor: default; }
@media (max-width: 767px) { .inbox-header { align-items: flex-start; flex-direction: column; } .inbox-toolbar { align-items: flex-start; flex-direction: column; } .inbox-toolbar > div:last-child { width: 100%; } .inbox-toolbar button { flex: 1; } }
</style>
